export default class MPGSClient {
  isConfigured = () => {
    return window.ThreeDS.isConfigured();
  };

  configure = (merchantId, sessionId, containerId, callback) => {
    window.ThreeDS.configure({
      callback,
      containerId,
      merchantId,
      sessionId,
      configuration: {
        wsVersion: process.env.REACT_APP_MPGS_JS_VERSION
      }
    });
  };

  initiateAuthentication = (orderId, transactionId, callback) => {
    const optionalParams = {
      sourceOfFunds: {
        type: 'CARD'
      }
    };

    window.ThreeDS.initiateAuthentication(orderId, transactionId, callback, optionalParams);
  };

  authenticatePayer = (orderId, transactionId, callback) => {
    window.ThreeDS.authenticatePayer(orderId, transactionId, callback, {});
  };

  onEvent = (event, callback) => {
    window.ThreeDS.onEvent(event, callback);
  };
}
